<template>
  <div>
    <hr class="border-1 border-top border-gray-500 mb-4 md:mb-8">

    <div class="mb-4 md:mb-8">
      <h3 class="font-bold text-lg md:text-2xl md:mb-2">
        Veiling agenda
      </h3>
      <template v-if="themeAuctionCalendars.length === 0">
        Geen veilingen gevonden.
      </template>
      <template v-else>
        <div
          v-for="(item, i) in themeAuctionCalendars"
          :key="`theme-auction-calendar-${i}`"
          class="truncate"
        >
          {{ item.date }}
          -
          <Link
            class="text-sky-500 underline hover:no-underline"
            :href="item.url"
          >
            {{ item.name }}
          </Link>
        </div>
      </template>
    </div>

    <hr class="border-1 border-top border-gray-500 mb-6 md:mb-8">

    <div class="mb-4 md:mb-8">
      <div class="mb-2 text-sm">
        <span class="px-1 bg-white border border-gray-400 text-gray-350 uppercase"><span class="text-green-500">A</span>-Grade artikel</span>
        <span class="ml-2">
          Artikel is in nieuwstaat
        </span>
      </div>
      <div class="mb-2 text-sm">
        <span class="px-1 bg-white border border-gray-400 text-gray-350 uppercase"><span class="text-yellow-500">B</span>-Grade artikel</span>
        <span class="ml-2">
          Artikel is een tweedekans
        </span>
      </div>
      <div class="mb-2 text-sm">
        <span class="px-1 bg-white border border-gray-400 text-gray-350 uppercase"><span class="text-pink-400">C</span>-Grade artikel</span>
        <span class="ml-2">
          Artikel is (licht) beschadigd
        </span>
      </div>
      <div class="mb-2 text-sm">
        <span class="px-1 bg-white border border-gray-400 text-gray-350 uppercase"><span class="text-red-500">D</span>-Grade artikel</span>
        <span class="ml-2">
          Artikel is gebruikt en beschadigd
        </span>
      </div>
    </div>

    <hr class="border-1 border-top border-gray-500 mb-6 md:mb-8">

    <div class="px-2 py-1 bg-white border border-gray-400 text-sm">
      <i class="fa fa-crown text-yellow-400 text-lg mr-4" />
      Jij hebt momenteel het hoogste bod
    </div>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue2';

export default {
  components: {
    Link,
  },

  props: {
    themeAuctionCalendars: {
      required: true,
      type: Array,
    },
  },
};
</script>
